export default __webpack_public_path__ + "static/media/nature_video.476c1987.mp4";